// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Tag, Popover } from 'antd'
import { StatusErrors } from 'constants/errors'

function decimalToBinary (dec) {
  return (dec >>> 0).toString(2)
}

function BinaryToDecimals (binaryValue) {
  const decimals = []
  const binaries = [...binaryValue]
  binaries.reverse().forEach((element, index) => {
    if (element === '1') decimals.push(Math.pow(2, index))
  })
  return decimals
}

function errorMessage (status) {
  if (status >= Math.pow(2, StatusErrors.length)) {
    return <div>{'Unknown error code'}</div>
  }
  let errorCodes = BinaryToDecimals(decimalToBinary(status))
  let errorDetails = StatusErrors.filter(obj => {
    return errorCodes.includes(obj.key)
  })
  const content = (
    <div>
      {errorDetails
        ? errorDetails.map(element => (
            <div key={element.key}>{`${element.key} [${element.name}] ${element.remark}`}</div>
          ))
        : 'Unknown error code'}
    </div>
  )
  return content
}

export default class HealthTag extends React.Component {
  render () {
    const { status } = this.props
    let text = 'Healthy'
    let color = 'green'
    if (status === 0) {
      return (
        <Tag {...this.props} color={color}>
          {text}
        </Tag>
      )
    } else {
      text = `Issue(${status})`
      color = 'orange'
      let content = errorMessage(status)
      return (
        <Popover content={content} placement='bottom' title='Error messages'>
          <Tag {...this.props} color={color}>
            {text}
          </Tag>
        </Popover>
      )
    }
  }
}
